import { isAllowed } from '@opsbase/lib-form/FormConstraints';
import FormQuestionType, { AllFormQuestionTypes, questionTypeTitle, } from '@opsbase/lib-form/FormQuestionType';
import i18n from '@opsbase/lib-i18n';
import useCallforward from '@opsbase/react-hooks/useCallforward';
import Columns from '@opsbase/web-layout/Columns/Columns';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane/Pane';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import QuestionTypeIcon from '@opsbase/web-opform-editor/QuestionTypeIcon';
import Button from '@opsbase/web-ui/Button/Button';
import IconTitle from '@opsbase/web-ui/IconTitle';
import Switch from '@opsbase/web-ui/Switch';
import React, { useCallback, useMemo } from 'react';
export function QuestionConstraints(props) {
    const { questionConstraint: qc, onChange } = props;
    const _changeTypes = useMemo(() => types => onChange({ ...qc, types }), [onChange, qc]);
    const handleAll = useCallback(() => _changeTypes(undefined), [_changeTypes]);
    const handleNone = useCallback(() => _changeTypes([]), [_changeTypes]);
    const handleToggle = useCallforward(qt => v => {
        var _a, _b, _c, _d;
        if (!((_a = qc.types) === null || _a === void 0 ? void 0 : _a.length) && !!v)
            return _changeTypes([qt]);
        if (!((_b = qc.types) === null || _b === void 0 ? void 0 : _b.length) && !v)
            return _changeTypes(AllFormQuestionTypes.filter(t => t !== qt));
        if (!!v)
            return _changeTypes([...(_c = qc.types) === null || _c === void 0 ? void 0 : _c.filter(t => t !== qt), qt]);
        if (!v)
            return _changeTypes((_d = qc.types) === null || _d === void 0 ? void 0 : _d.filter(t => t !== qt));
    }, [_changeTypes, qc.types]);
    return (React.createElement(Vertical, { gutter: true, style: { maxWidth: 1000, margin: 'auto' } },
        React.createElement(Columns, { noOfCols: 2, gutter: 2 }, Object.values(FormQuestionType).map(qt => {
            return (React.createElement(Horizontal, { gutter: true, key: qt },
                React.createElement(Pane, null,
                    React.createElement(Switch, { checked: isAllowed(qc, qt), onChange: handleToggle(qt) })),
                React.createElement(Pane, { grow: true },
                    React.createElement(IconTitle, { style: { minWidth: 200 }, title: questionTypeTitle(qt), icon: React.createElement(QuestionTypeIcon, { type: qt }) }))));
        })),
        React.createElement(Horizontal, { padding: true, gutter: true },
            React.createElement(Pane, { grow: true }),
            React.createElement(Button, { small: true, label: i18n.t('select-all'), onClick: handleAll }),
            React.createElement(Button, { small: true, label: i18n.t('select-none'), onClick: handleNone }),
            React.createElement(Pane, { grow: true }))));
}
export default QuestionConstraints;
